import React from 'react';

export const CTA = () => {
  return (
    <section className="laprf-cta">
      <div className="laprf-cta-bottom-container">
        <div className="laprf-cta-text-section">
          <p className="laprf-cta-description">
            <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
              Lap after lap,
            </span>
            <span style={{ whiteSpace: 'nowrap', display: 'block' }}>
              flawless timing.
            </span>
          </p>
          <div className="dreamX__discover--button">
            <a
              href="https://shop.orqafpv.com/products/immersionrc-laprf-8?_pos=1&_sid=19f8b9194&_ss=r"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={event => event.preventDefault()}
            >
              buy now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
